<div class="col-lg-12 col-md-12 col-xs-12 padding0px">  
    <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
      <dx-data-grid class="dashboard-grid" #dgSetDates
                    id="dgSetDates"
                    [dataSource]="__oTradingCounterpartyLimits"
                    [keyExpr]="CompositeKey"
                    [allowColumnResizing]="true"
                    columnAutoWidth="true"
                    (onEditorPreparing)="onEditorPreparing($event)"
                     [hoverStateEnabled]="true"
                    (onRowPrepared)="onRow_Prepared($event)">

        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-paging [pageSize]="1000"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="__oTradingCounterpartyLimits.length > 0"
                   [allowedPageSizes]="[10, 100 ,1000]"
                   [showInfo]="true"
                   [visible]="__oTradingCounterpartyLimits.length > 0"
                   [showNavigationButtons]="true"
                   [displayMode]="'full'">
        </dxo-pager>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-filter-row [visible]="true"
                        applyFilter="auto"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>


        <dxo-editing mode="cell"
                     [allowUpdating]="true">
        </dxo-editing>

        <dxi-column dataField="TradingCounterpartyName"
                    caption="Counterparty" [width]="200"
                    [allowEditing]="false">
        </dxi-column>
        <dxi-column dataField="TradingEntityName"
                    caption="Trading Entity " [width]="200"
                    [allowEditing]="false">
        </dxi-column>

        <dxi-column dataField="LimitTypeName"
                    caption="Limit Type" [width]="200"
                    [allowEditing]="false">
        </dxi-column>
        <dxi-column dataField="From" dataType="text" [allowEditing]="false" [format]="__sPortalFromToDateFormat" caption="Overall Start Date"></dxi-column>
        <dxi-column dataField="To" dataType="text" [allowEditing]="false" [format]="__sPortalFromToDateFormat" caption="Overall End Date"></dxi-column>
        <dxi-column [visible]="false" dataField="IsAutoRollOver" dataType="boolean" caption="Auto Rollover"></dxi-column>
        <dxi-column dataField="StartDate" [visible]="false" dataType="date" [format]="__sPortalDateFormat" caption="Effective Date"></dxi-column>
        <dxi-column dataField="LastReviewDate" dataType="date" [format]="__sPortalDateFormat" cellTemplate="cellTemplateDate" editCellTemplate='editCellTemplateDate' caption="Last Review Date"></dxi-column>
        <dxi-column dataField="NextReviewDate" dataType="date" [format]="__sPortalDateFormat" cellTemplate="cellTemplateDate" editCellTemplate='editCellTemplateDate' caption="Next Review Date"></dxi-column>
        <dxi-column dataField="EndDate" [visible]="false" dataType="date" [format]="__sPortalDateFormat" caption="Expiry Date"></dxi-column>
        <dxi-column cellTemplate="cellInfoTemplate" caption=""  [width]="50" [allowEditing]="true" fixedPosition="right" fixed="true" allowHiding="false" showInColumnChooser="false"></dxi-column>
        <div *dxTemplate="let Info of 'editCellTemplateDate'">
          <app-date-picker type="date" [value]="Info.data[Info.column.dataField]" (onDatePickerValueChanged)="onDateValueChanged(Info.data,Info, $event)"
                       [displayFormat]="__sPortalDateFormat" [format]="__sPortalDateFormat" style="width:100% !important">
          </app-date-picker>
        </div>
        <div *dxTemplate="let Info of 'cellTemplateDate'" [ngClass]="{'parent-entity-lock':isEntityRestrictedRow(Info)}">
          <i *ngIf="isEntityRestrictedRow(Info)" class='glyphicon glyphicon-lock entity-lock'></i>
          <div class="col-lg-12 col-sm-12 col-md-12  padding-left-20" style="text-align:left">
            <span>{{Info.data[Info.column.dataField]| date: __sPortalDateFormat}}</span>
          </div>
        </div>
        <div *dxTemplate="let Info of 'cellInfoTemplate'" style="text-align: center;">
          <i *ngIf="isEntityRestrictedRow(Info)" id="btninfo" type="button" class="btn-info-icon-round info-button" title="You don't have permission to make changes on this row."></i>
        </div>
      </dx-data-grid>
    </div>    
</div>
